export default __webpack_public_path__ + "static/media/WHITE-04 3.4ab827bd.png";